// The demo fixtures were written as of FIXTURE_TODAY. Shifting every date by the
// days since then keeps "today's shoot", "closings in 30 days" and the activity
// feed current whenever someone opens the demo, instead of reading months stale.
export const FIXTURE_TODAY = '2026-07-04';
const DAY = 86400000;

function todayUtc(now = new Date()) {
  return Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
}

export function shiftDaysFor(now = new Date()) {
  return Math.max(0, Math.round((todayUtc(now) - Date.parse(`${FIXTURE_TODAY}T00:00:00Z`)) / DAY));
}

export const SHIFT_DAYS = shiftDaysFor();

const DATE = /^\d{4}-\d{2}-\d{2}$/;
const DATETIME = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?)(Z|[+-]\d{2}:\d{2})?$/;

export function shiftDate(s, days = SHIFT_DAYS) {
  if (typeof s !== 'string' || !days) return s;
  if (DATE.test(s)) return new Date(Date.parse(`${s}T12:00:00Z`) + days * DAY).toISOString().slice(0, 10);
  const m = DATETIME.exec(s);
  if (!m) return s;
  const ms = Date.parse(s);
  if (Number.isNaN(ms)) return s;
  const out = new Date(ms + days * DAY).toISOString();
  return m[2] && m[2] !== 'Z' ? `${out.slice(0, 19)}${m[2]}` : out.replace('.000Z', 'Z');
}

// Shifts date strings in place, once per object even when lists share rows.
export function shiftDeep(value, days = SHIFT_DAYS, seen = new WeakSet()) {
  if (!days || !value || typeof value !== 'object' || seen.has(value)) return value;
  seen.add(value);
  Object.keys(value).forEach((k) => {
    const v = value[k];
    if (typeof v === 'string') value[k] = shiftDate(v, days);
    else if (v && typeof v === 'object') shiftDeep(v, days, seen);
  });
  return value;
}

const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const at = (iso) => new Date(`${iso}T12:00:00Z`);
export const ymOf = (iso) => iso.slice(0, 7);
export const prevYm = (iso, back = 1) => { const d = at(iso); d.setUTCDate(1); d.setUTCMonth(d.getUTCMonth() - back); return d.toISOString().slice(0, 7); };
export const monthName = (iso) => MONTHS[at(iso).getUTCMonth()];
export const weekdayName = (iso) => DAYS[at(iso).getUTCDay()];
export function isoWeek(iso) {
  const d = at(iso);
  const dayNum = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - dayNum);
  const yearStart = Date.UTC(d.getUTCFullYear(), 0, 1);
  return Math.ceil(((d - yearStart) / DAY + 1) / 7);
}
